import classNames from 'clsx';
import type { ReactElement } from 'react';
import React from 'react';

import type { GlobalFieldReference } from '@swf/cms';
import { CMSReference } from '@swf/cms';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import CloseIcon from '@swf/core/assets/icons/cross.svg';
import type { Accordion } from '@swf/generated/cms/types/Accordion';

import styles from './PanelItem.scss';

interface Props {
  body: GlobalFieldReference[];
  expanded: boolean;
  onClick: () => void;
  collapsedTitle?: string;
  expandedTitle?: string;
  element?: ReactElement;
  theme?: Accordion['theme'];
  buttonType?: Accordion['button_type'];
}

const PanelItem: React.FC<Props> = ({
  body,
  theme = 'Default',
  buttonType = 'Cross',
  collapsedTitle,
  expandedTitle,
  expanded,
  element,
  onClick
}) =>
  body?.length || element ? (
    <div
      className={classNames({
        [styles.cardLite]: theme === 'Lite',
        [styles.card]: theme === 'Default'
      })}
    >
      <div className={styles.cardHeader}>
        <button
          className={classNames(styles.cardTitleButton, {
            [styles.active]: expanded,
            [styles.cardTitleButtonStyle]: theme === 'Default',
            [styles.cardTitleButtonStyleLite]: theme === 'Lite'
          })}
          type="button"
          onClick={onClick}
        >
          <span
            className={classNames({
              [styles.text]: theme === 'Default',
              [styles.textLite]: theme === 'Lite'
            })}
          >
            {expanded ? expandedTitle : collapsedTitle}
          </span>
          <span
            className={classNames({
              [styles.controlCross]: buttonType === 'Cross',
              [styles.controlArrow]: buttonType === 'Arrow'
            })}
          >
            {buttonType === 'Cross' ? <CloseIcon /> : <Arrow width={15} height={15} />}
          </span>
        </button>
      </div>
      <div className={classNames(styles.collapse, { [styles.show]: expanded })}>
        <div className={styles.cardBody}>
          {body?.map((item, itemIndex) => (
            <CMSReference key={itemIndex} {...item} />
          ))}
          {element && element}
        </div>
      </div>
    </div>
  ) : null;

export default PanelItem;
